export enum InventoryAdjustmentLineAction {
  ADD = 'add',
  REMOVE = 'remove',
}
